import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";

/**
 * Resets all Recoil atoms/selectors used by the Manage Seating flow
 * and related checkout seating state so other pages don't assume
 * the manage seating context is still active.
 */
export const resetManageSeatingState = (): void => {
  // Seating map and selection state
  updateRecoilState("seatSelectorOpenAtom", false);
  updateRecoilState("selectedSeatsAtom", []);
  updateRecoilState("confirmedSeatsAtom", []);
  updateRecoilState("originalSeatsAtom", []);
  updateRecoilState("placeMapResponseAtom", null);
  updateRecoilState("coachLayoutResponseAtom", null);
  updateRecoilState("floorPlanIconsResponseAtom", null);
  updateRecoilState("seatServiceClassAtom", []);
  updateRecoilState("seatTravelClassAtom", []);
  updateRecoilState("selectedCoachAtom", "");
  updateRecoilState("unavailableSeatsAtom", []);
  updateRecoilState("initiallyAvailableSeatsAtom", null);
  updateRecoilState("passengerSeatCursorAtom", []);

  // Flags and context toggles
  updateRecoilState("isManageSeatingAtom", false);
  updateRecoilState("isHyperFastStateAtom", false);
  //updateRecoilState("isQuickExchangeStateAtom", false);

  // Input contexts used during manage seating
  updateRecoilState("displayPassengerDataAtom", null);
  updateRecoilState("selectedTripsDataAtom", null);

  // Payment summary will be recomputed by target screens (e.g., Booking Details)
  updateRecoilState("checkoutPaymentSummaryAtom", null);

  updateRecoilState("manageSeatingBaselineAddonsLegPassengerAtom", {});
};


